// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__container--NmzsG{cursor:initial;display:grid;font-size:11px !important}.index-module__text--aPbGE{display:flex;align-items:center}.index-module__avatar-container--k3QCu{display:flex;align-items:center;justify-items:center}.index-module__audit-log-avatar--Cb2Wp{margin:0 5px;display:inline-block !important}.index-module__view-log-button--DZRqt{font-size:11px;color:dimgray;cursor:pointer}.index-module__view-log-button--DZRqt:hover{text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container--NmzsG`,
	"text": `index-module__text--aPbGE`,
	"avatar-container": `index-module__avatar-container--k3QCu`,
	"avatarContainer": `index-module__avatar-container--k3QCu`,
	"audit-log-avatar": `index-module__audit-log-avatar--Cb2Wp`,
	"auditLogAvatar": `index-module__audit-log-avatar--Cb2Wp`,
	"view-log-button": `index-module__view-log-button--DZRqt`,
	"viewLogButton": `index-module__view-log-button--DZRqt`
};
export default ___CSS_LOADER_EXPORT___;
